<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Tareas Manuales Pendientes de Asignar</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <button
                class="btn btn-sm btn-success"
                @click="ModalAggTareaManual()"
              >
                <i class="fa fa-plus"></i> &nbsp; Crear tarea manual
              </button>
            </div>
            <div class="col-sm-12">
              <div>
                <span class="font-weight-bold text-dark text-center"
                  >Solo mis tareas
                </span>
                <label class="switch">
                  <input
                    class="text-center"
                    v-model="filter.mis_tareas"
                    type="checkbox"
                    @change="refreshData()"
                  />
                  <span class="slider-button"></span>
                </label>
              </div>
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar Numero"
                  v-model="filter.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData()"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TareaManualTableComponent :dataTabla="mis_tareas" />
        <CrearTareaManualModalComponent />
        <PaginationComponent
          :currentPage="currentPage"
          :data="mis_tareas"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import TareaManualTableComponent from "@/components/wms/tareas_manuales/TareaManualTableComponent";
import CrearTareaManualModalComponent from "@/components/wms/tareas_manuales/CrearTareaManualModalComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    TareaManualTableComponent,
    UsuarioEnTablaComponent,
    UsuariosSelectComponent,
    PaginationComponent,
    CrearTareaManualModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      mis_tareas: [],
      filter: {
        mis_tareas: true,
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        fecha_creacion: "",
        numero: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.refreshData();
  },
  methods: {
    ModalAggTareaManual() {
      let self = this;
      $("#crearTareaManualModal").modal("show");
    },
    refreshData() {
      let self = this;
      DynamicService.fetch("wms", "tareas", {
        mis_tareas: self.filter.mis_tareas,
        tareas_manuales: true,
        estado: "A",
      }).then((resp) => {
        self.mis_tareas = resp.data.results;
      });
    },
    filterData(page) {
      let self = this;
      if (page) {
        this.currentPage = page;
      }

      DynamicService.fetch("wms", "tareas", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        mis_tareas: true,
        tareas_manuales: true,
        estado: "A",
        numero: this.filter.numero,
      }).then((response) => {
        this.mis_tareas = response.data.results;
        console.log(response.data.results);
      });
    },
    clearFilterData() {
      this.filter.numero = "";
      this.refreshData();
    },
  },
};
</script>
